import axios from "axios";
axios.defaults.baseURL= process.env.VUE_APP_BASEURL
// axios.defaults.baseURL="http://192.168.0.139:8888/buyer"
export default axios